import { buildAttachmentAwareRequest } from 'repositories/utils/attachmentRequest'

import { berthApiClient } from '../berthApiClient'

import { updateUnassignedBookingEndpoint } from './endpoint'
import type { UpdateUnassignedBookingParams, UpdateUnassignedBookingResponse } from './type'

export const updateUnassignedBooking = async (
  params: UpdateUnassignedBookingParams
): Promise<UpdateUnassignedBookingResponse> => {
  const { body, config } = buildAttachmentAwareRequest(params)
  const res = await berthApiClient.put<UpdateUnassignedBookingResponse>(
    updateUnassignedBookingEndpoint,
    body,
    config
  )
  return res.data
}
